// Task Manager Type Definitions

export interface TaskUser {
  id: number;
  name: string;
  phonenum?: string;
  profileimageuri?: string;
  image?: string;
}

export interface TaskNode {
  id: string;
  name: string;
  label?: string;
  display: string;
  piv_level0?: string;
  piv_level1: string;
  piv_level2?: string;
  booth_map?: string;
  booth_info?: string;
}

export interface TaskCount {
  count: number;
}

export interface TaskQAStatus {
  valid: number;
  invalid: number;
  "not-checked": number;
}

export interface TaskStatus {
  progress_field_work: number;
  progress_qa: number;
  pending: number;
  by_qastatus: TaskQAStatus;
  surveys?: any[];
  by_loc?: {
    loc_summary?: {
      done: number;
      ref: number;
      percent: number;
    };
    loc_coverage?: Record<string, any>;
  };
}

export interface TaskMore {
  name: string;
  marked_locations?: MarkedLocation[];
}

export interface Task {
  id: number;
  projectid: number;
  surveyid: number;
  assigned: boolean;
  user?: TaskUser;
  userid?: number;
  node: TaskNode;
  count: TaskCount;
  status: TaskStatus;
  more: TaskMore;
  logs?: TaskLog[];
}

export interface TaskLog {
  op: string;
  when: string;
  who: {
    name: string;
  };
}

export interface MarkedLocation {
  id: string;
  lat: number;
  lng: number;
  radius: number;
}

export interface TaskFilters {
  userList: number[];
  pivLevel1: string[];
  status: TaskStatusType[];
  surveys: any[];
}

export type TaskStatusType = "not-started" | "in-progress" | "completed";

export type ViewMode = "card" | "table";

export interface PaginationState {
  page: number;
  pageSize: number;
  total: number;
}

// Utility function to determine task status
export const getTaskStatus = (task: Task): TaskStatusType => {
  const fieldWork = task.status?.progress_field_work ?? 0;
  const qa = task.status?.progress_qa ?? 0;

  if (fieldWork === 100 && qa === 100) return "completed";
  if (fieldWork > 0 || qa > 0) return "in-progress";
  return "not-started";
};

// Status display config
export const STATUS_CONFIG: Record<
  TaskStatusType,
  { label: string; color: string; bg: string; icon: string }
> = {
  "not-started": {
    label: "Not Started",
    color: "text-slate-600",
    bg: "bg-slate-100",
    icon: "fa-circle",
  },
  "in-progress": {
    label: "In Progress",
    color: "text-amber-600",
    bg: "bg-amber-50",
    icon: "fa-spinner",
  },
  completed: {
    label: "Completed",
    color: "text-emerald-600",
    bg: "bg-emerald-50",
    icon: "fa-circle-check",
  },
};

